import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import { TermCategoryRow } from '@models/term/termCategory';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

interface Props {
    termCategory: TermCategoryRow;
}

function PolicyRow({ termCategory }: Props) {
    const { t } = useTranslation('accountSetting');
    const { title, id } = termCategory;
    return (
        <Row fullWidth justify='space-between' align='center'>
            <Text color={colors.textPrimary}>{title}</Text>
            <Link activityName='TermDetailActivity'
                activityParams={{ termCategoryId: id }} >
                <Text color={colors.primary}
                    fontWeight='bold'
                    css={linkCss}>
                    {t('policies.view')}
                </Text>
            </Link>
        </Row>
    );
}

const linkCss = css`
    text-decoration: underline;
    text-underline-offset: 2px;
`;

export default PolicyRow;
